import logo from "./logo.svg";
import "./App.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route, Link, Outlet } from "react-router-dom";
import NavBar from "./components/NavBar/NavBar";
import ScrollToTop from "./components/scrollToTop";
import { Home } from "./pages/Home/Home";
import { Footer } from "./components/Footer/Footer";
import { CoursePage } from "./pages/CoursePage/CoursePage";
import { Welcome } from "./pages/Welcome/Welcome";
import { Phylosophy } from "./pages/Phylosophy/Phylosophy";
import { Directory } from "./pages/Directory/Directory";
import { PhysicsOverview } from "./pages/PhysicsOverview/PhysicsOverview";
import { Undergraduates } from "./pages/Undergraduates/Undergraduates";
import { CurrentUnderG } from "./pages/CurrentUndergraduates/CurrentUnderG";
import { PostGraduate } from "./pages/PostGraduate/PostGraduate";
import { ResearchOverview } from "./pages/ResearchOverview/ResearchOverview";
import { ResearchGroups } from "./pages/ResearchGroups/ResearchGroups";
import { MainResearch } from "./pages/ResearchGroups/MainResearch/MainResearch";
import { ResearchProgrammes } from "./pages/ResearchProgrammes/ResearchProgrammes";
import { Serminars } from "./pages/Serminars/Serminars";
import { DegreeStructure } from "./pages/DegreeStructur/DegreeStructure";
import { Contact } from "./pages/Contact/Contact";
import { Alumni } from "./pages/Alumni/Alumni";
import { NewsPage } from "./pages/NewsPage/NewsPage";
import { MainNews } from "./pages/NewsPage/MainNews/MainNews";
import { Terms } from "./pages/Terms/Terms";
import Loader from "./components/Loader/Loader";
import usePageLoader from "./usePageLoader";
import { PGDPage } from "./pages/PGDPage/PGDPage";
function App() {
  const loading = usePageLoader();
  return (
    <>
      {loading && <Loader />}
      <ScrollToTop />
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="course-page" element={<CoursePage />} />
        <Route path="pgd-courses" element={<PGDPage />} />
        <Route path="welcome" element={<Welcome />} />
        <Route path="phylosophy" element={<Phylosophy />} />
        <Route path="directory" element={<Directory />} />
        <Route path="physics-overview" element={<PhysicsOverview />} />
        <Route path="undergraduates" element={<Undergraduates />} />
        <Route path="current-undergraduates" element={<CurrentUnderG />} />
        <Route path="post-undergraduate" element={<PostGraduate />} />
        <Route path="research-overview" element={<ResearchOverview />} />
        <Route path="research-groups" element={<ResearchGroups />} />
        <Route path="main-research" element={<MainResearch />} />
        <Route path="research-programmes" element={<ResearchProgrammes />} />
        <Route path="serminars" element={<Serminars />} />
        <Route path="degree-structure" element={<DegreeStructure />} />
        <Route path="contact" element={<Contact />} />
        <Route path="alumni" element={<Alumni />} />
        <Route path="news-page" element={<NewsPage />} />
        <Route path="terms" element={<Terms />} />
        <Route path="main-news/:blog_id" element={<MainNews />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
